const Status = {
    RECADASTRAMENTO_PENDENTE: 'RECADASTRAMENTO_PENDENTE',
    NAO_VALIDADO: 'NAO_VALIDADO',
    SEM_VALIDACAO: 'SEM_VALIDACAO',
    COM_VALIDACAO: 'COM_VALIDACAO',
    ALTERADO: 'ALTERADO',
    CONFIRMADO:'CONFIRMADO',
    VALIDADO:'VALIDADO',
    PENDENTE_DE_VALIDACAO: 'PENDENTE_DE_VALIDACAO',
    PENDENTE_VALE_TRANSPORTE:'PENDENTE_VALE_TRANSPORTE',
    ATUALIZADO:'ATUALIZADO',

    // Método valueOf para obter o valor a partir do nome
    valueOf: function(name) {
        return this[name];
    },

    // Método values para retornar todos os valores
    values: function() {
        return Object.values(this);
    }
};

export default Status




// WEBPACK FOOTER //
// ./src/pages/recadastramento/envio/status.js